/**
 * Created by rhinov15 on 17/03/2016.
 *
 * Node displaying windows in the 2d scene
 */

import { JoineryNode } from "../JoineryNode";
import { PlanManager } from "../../../../../cocosPlan";
import { Events, eventsManager, SceneConstants, Window } from "@rhinov/savane-js";

declare var cc: any;

export class WindowNode extends JoineryNode {

    //@private
    protected _nbCasement: number = 1;
    //@private
    protected _openingMode: number = SceneConstants.OpeningMode.mode_default;
    //@private
    protected _slideDirection: number = SceneConstants.SlideDirection.slide_left;
    //@private
    protected _handleSide: number = SceneConstants.HandleSide.handle_left;
    //@private
    protected _openingSymetry: number = SceneConstants.Symetry.default;

    constructor(jWindow: Window) {
        super(jWindow);
        // Load sprite for the display
        this.computeModel(jWindow);
    }

    getY(h: number): number {
        switch (this._wallInstallTye) {
            case 1:
                return -(this._thickness * 0.1) * 0.5;
            case 0:
                return (-h * 0.5);
            case -1:
                return ((this._thickness * 0.1) * 0.5 - 15);
        }
        return 0;
    }

    // Draw background rectangles
    drawOverlap(_joinery: Window, isValid: boolean) {
        var alpha = 255;
        if (this.transparentDraw) {
            alpha = 64;
        }
        // Clear the node content
        this.clear();

        if (this._thickness > 0) {
            // Compute width and height of the box to draw
            var h = (this._thickness * 0.1);
            var w = this._length * 0.1 - 1;
            var y = -h * 0.5;
            var x = -w * 0.5;

            // Drawing color
            var color: {border: any, plain:any} = {border: undefined, plain: undefined};

            if (isValid !== undefined) {
                color = this.getOverLapColor(isValid);
            }
            else {
                color = this.getOverLapColor(true);
            }

            // Size of the border (depends on the zoom value)
            var borderSize = 1;
            if (borderSize * PlanManager.getInstance().getZoomScale() < 1) {
                borderSize /= PlanManager.getInstance().getZoomScale();
            }

            var white = new cc.color(255, 255, 255, alpha);
            // Draw main rectangle where the window is
            this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), white, borderSize, white);

            // Default door thickness
            h = (150 * 0.1);

            y = this.getY(h);

            this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), color.plain, borderSize, color.border);

            var val2 = 0.066;
            var val1 = 0.015;

            if (this._handleSide === SceneConstants.HandleSide.handle_left && this._nbCasement === 1) {
                val2 = 0.015;
                val1 = 0.066;
            }
            else {
                if (this._nbCasement !== 1) {
                    val1 = 0.032;
                    val2 = 0.032;
                }
            }
            if (!this._orientation) {
                var tmp = val1;
                val1 = val2;
                val2 = tmp;
            }
            if (this._nbCasement > 1 && this._openingMode === SceneConstants.OpeningMode.mode_default) {
                for (var i = 0; i < this._nbCasement; ++i) {
                    var anchor = i / this._nbCasement;
                    this.drawRect(new cc.p(x + w * anchor - w * 0.009, y - 0.5), new cc.p(x + w * anchor + w * 0.009, y + h + 0.5),
                        new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
                }
            }
            this.drawRect(new cc.p(x - 0.5, y - 0.5), new cc.p(x + w * val1, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
            this.drawRect(new cc.p(x + w - w * val2, y - 0.5), new cc.p(x + w + 0.5, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
        }
    }

    // Load the right sprite to display
    computeModel(joinery: Window) {
        if (joinery !== undefined) {
            // Get joinery properties
            this._nbCasement = joinery.nbCasement;
            this._openingMode = joinery.openingMode;
            this._slideDirection = joinery.slideDirection;
            this._handleSide = joinery.handleSide;
            this._openingSymetry = joinery.openingSymetry;
            this._length = joinery.length;
            this._orientation = joinery.orientation;

            // Get joinery thickness from wall if it exists
            if (joinery.wall !== null) {
                this._thickness = joinery.wall.thickness;
            }
            else {
                this._thickness = this._length / 10;
            }
            this._wallInstallTye = joinery.wallInstallType;
        }

        // This is commented since useless further (we can remove this code if we don't want sprite mip map)
        /*
        // Compute ideal sprite size corresponding to the current zoom scale
        var idealSize = (this._length / 10 / this._nbCasement) * PlanManager.getInstance().getZoomScale();
        // And compute the closest value to what we have (power 2 sizes from 32 pixels to 512)
        var foundSize = Utils.getClosestNumberInArray(idealSize, JoineryNode.ImageSizeExtentions);

        // If nothing approaching, use the 1st value of image size extensions
        if (foundSize === 0)
        {
            foundSize = JoineryNode.ImageSizeExtentions[0];
        }
        */

        // Create one sprite per casement
        for (var i = 0; i < this._nbCasement; ++i) {
            // Create sprite to display one per casement
            var sprite = new cc.Sprite();
            // Load correct sprite (window for standard opening mode, bayBot for sliding door)
            var spriteName = this._openingMode === SceneConstants.OpeningMode.mode_default ? 'plan/window.png' : 'plan/bayBot.png';
            // Load sprite image
            sprite.initWithSpriteFrameName(spriteName);
            // Set sprite anchor
            sprite.setAnchorPoint(new cc.p((i + 1) - (this._nbCasement * 0.5), this._openingMode == SceneConstants.OpeningMode.mode_default ? 1 : 1));

            if (this.transparentDraw) {
                sprite.setOpacity(64);
            }

            // Compute scale
            var scaleY = this._length / (sprite.width * 10 * this._nbCasement);

            if (this._openingMode === SceneConstants.OpeningMode.mode_default) {
                if (this._thickness != 0) {
                    // recompute to match actual position set below
                }
                sprite.setPositionY(this.getY(15));
            }
            else {
                if (this.thickness != 0) {
                    sprite.setPositionY(this.getY(15));
                    scaleY = 0.25;
                    //if (scaleY * PlanManager.getInstance().getZoomScale() < 0.25){
                    //    scaleY /= PlanManager.getInstance().getZoomScale();
                    //}
                }
            }
            // Sprite scale X and Y
            sprite.setScaleX(this._length / (sprite.width * 10 * this._nbCasement));
            sprite.setScaleY(scaleY);
            // Sprite name
            sprite.setName('casement-' + i);

            if (this._openingSymetry === SceneConstants.Symetry.default && i % 2 === 0) {
                sprite.setFlippedX(true);
            }

            // Handle side management only if less than 2 casements
            if (this._nbCasement < 2) {
                // right + !orientation and left + orientation = no flip
                if (this._handleSide !== SceneConstants.HandleSide.handle_left && !this._orientation
                    || this._handleSide === SceneConstants.HandleSide.handle_left && this._orientation) {
                    sprite.setFlippedX(false);
                }

                // right + orientation and left + ! orientation = flip
                if (this._handleSide !== SceneConstants.HandleSide.handle_left && this._orientation
                    || this._handleSide === SceneConstants.HandleSide.handle_left && !this._orientation) {
                    sprite.setFlippedX(true);
                }
            }
            // Add the sprite to the node
            this.addChild(sprite, 8);
        }
    }

    // Update node content
    updateModel(joinery: Window, isValid: boolean) {
        this.removeAllChildren();
        this.computeModel(joinery);
        super.updateModel(joinery, isValid);
        this.drawOverlap(joinery, isValid);
    }

    // Object creation, attach a listener that listens to zoom events
    onEnter() {
        super.onEnter();
        this.scrollListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, () => {
            // Remove all sprites from the node and readd them to load the right sprite size
            for (var i = 0; i < this._nbCasement; ++i) {
                this.removeChild(this.getChildByName('casement-' + i));
            }
            this.computeModel(this.savaneEntity as Window);
        });
    }

    // Object destruction, delete the zoom listener
    onExit() {
        super.onExit();
        eventsManager.instance.removeListener(this.scrollListener);
    }
}
